/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, G, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function PhoneX(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <G>
        <Path d="M221.97168,158.42676l-46.83789-20.07324a15.94874,15.94874,0,0,0-15.17871,1.39453l-25.043,16.69336A76.54083,76.54083,0,0,1,99.707,121.3916l.00195-.00195,16.63477-25.418a15.96924,15.96924,0,0,0,1.32031-15.06641L97.57227,34.02734a16.03093,16.03093,0,0,0-16.65235-9.583A56.07029,56.07029,0,0,0,32,80c0,79.40234,64.59766,144,144,144a56.07032,56.07032,0,0,0,55.55566-48.9209A16.03476,16.03476,0,0,0,221.97168,158.42676Z" />
        <Path d="M154.34277,101.65723a8.00181,8.00181,0,0,0,11.31446,0L184,83.31445l18.34277,18.34278a8.00053,8.00053,0,0,0,11.31446-11.31446L195.31445,72l18.34278-18.34277a8.00053,8.00053,0,0,0-11.31446-11.31446L184,60.68555,165.65723,42.34277a8.00053,8.00053,0,0,0-11.31446,11.31446L172.68555,72,154.34277,90.34277A8.00122,8.00122,0,0,0,154.34277,101.65723Z" />
      </G>
    </Svg>
  );
}

export default PhoneX;
